const EMAIL_REGEX =
  /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
export const AUTH_PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$&*~]).{8,}$/;
const PHONE_REGEX = /^\+?[0-9]{10,15}$/;
const CAPTCHA_ALLOWED_REGEX = /^[A-Za-z0-9]+$/;

export const validateNomenclatureEmail = (
  value,
  {
    required = true,
    blockedDomains = [],
  } = {}
) => {
  const raw = value == null ? '' : String(value);
  const lower = raw.trim().toLowerCase();
  const errors = [];

  if (!lower) {
    if (required) errors.push('Email is required.');
    return { isValid: errors.length === 0, value: '', errors };
  }

  if (lower.length > 254) {
    errors.push('Email must be 254 characters or fewer.');
  }

  if (/\s/.test(lower)) {
    errors.push('Email cannot contain spaces.');
  }

  const atCount = (lower.match(/@/g) || []).length;
  if (atCount !== 1) {
    errors.push('Email must contain a single @ symbol.');
  }

  if (lower.includes('..')) {
    errors.push('Email cannot contain consecutive dots.');
  }

  const [localPart = '', domainPart = ''] = lower.split('@');
  if (!localPart || !domainPart) {
    errors.push('Email must have local and domain parts.');
  }

  const domainSegments = domainPart.split('.');
  if (domainSegments.some((seg) => !seg)) {
    errors.push('Domain must be valid.');
  }
  const tld = domainSegments[domainSegments.length - 1] || '';
  if (tld.length < 2) {
    errors.push('Domain TLD must be at least 2 characters.');
  }

  if (!EMAIL_REGEX.test(lower)) {
    errors.push('Enter a valid email address.');
  }

  if (blockedDomains.length && domainPart) {
    const domainMatches = blockedDomains.some(
      (blocked) => domainPart === blocked || domainPart.endsWith(`.${blocked}`)
    );
    if (domainMatches) {
      errors.push('Email domain is not allowed.');
    }
  }

  return {
    isValid: errors.length === 0,
    value: lower,
    errors,
  };
};

export const validateAuthPassword = (value, { required = true } = {}) => {
  const raw = value == null ? '' : String(value);
  const errors = [];

  if (!raw) {
    if (required) errors.push('Password is required.');
    return { isValid: errors.length === 0, value: raw, errors };
  }

  if (!AUTH_PASSWORD_REGEX.test(raw)) {
    errors.push('Password must include uppercase, lowercase, number and special character.');
  }

  if (raw.length > 128) {
    errors.push('Password must be at most 128 characters.');
  }

  return { isValid: errors.length === 0, value: raw, errors };
};

export const validateAuthPhoneNumber = (
  value,
  { required = true } = {}
) => {
  const raw = value == null ? '' : String(value).trim();
  const errors = [];

  if (!raw) {
    if (required) errors.push('Phone number is required.');
    return { isValid: errors.length === 0, value: '', errors };
  }

  if (!PHONE_REGEX.test(raw)) {
    errors.push('Enter a valid phone number.');
  }

  return { isValid: errors.length === 0, value: raw, errors };
};

export const validateCaptchaValue = (
  value,
  { required = true, minLength = 1, maxLength = 10 } = {}
) => {
  const raw = value == null ? '' : String(value);
  const errors = [];
  const trimmed = raw.trim();

  if (!trimmed) {
    if (required) errors.push('Captcha is required.');
    return { isValid: errors.length === 0, value: '', errors };
  }

  if (trimmed.length < minLength) {
    errors.push(`Captcha must be at least ${minLength} characters.`);
  }
  if (trimmed.length > maxLength) {
    errors.push(`Captcha must be at most ${maxLength} characters.`);
  }
  if (!CAPTCHA_ALLOWED_REGEX.test(trimmed)) {
    errors.push('Captcha contains invalid characters.');
  }

  return { isValid: errors.length === 0, value: trimmed, errors };
};
